import { ButtonBase, Collapse, styled, Link, Typography, useMediaQuery, useTheme } from "@mui/material"
import { memo } from "react"
import { Stack } from "src/shared/components"
import { ISidebarItemCommon } from "."
import { useNavigate } from "react-router-dom"
import { useGlobalConfig } from "src/shared/context/globalConfigContext"

const SidebarSubMenu = memo(({ isOpenSubMenu, subMenu }: { isOpenSubMenu: boolean; subMenu: ISidebarItemCommon[] }) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"))
  const { toggleSidebar } = useGlobalConfig()
  return (
    <Collapse in={isOpenSubMenu} timeout={100} unmountOnExit sx={{ p: 1 }}>
      <Stack direction="column" spacing={1} ml={2}>
        {subMenu.map(({ icon, title, href }, i) => (
          <Link href={href as string} key={`${title}-${i}`}>
            <SubMenuItem
              key={`${title}-${i}`}
              onClick={() => {
                if (href) navigate(href)
                if (isMdDown) toggleSidebar()
              }}
            >
              {icon}
              <Typography variant="body2" fontWeight={400}>
                {title}
              </Typography>
            </SubMenuItem>
          </Link>
        ))}
      </Stack>
    </Collapse>
  )
})

const SubMenuItem = styled(ButtonBase)(({ theme }) => ({
  width: "100%",
  padding: "8px",
  justifyContent: "left",
  "&:hover": { background: theme.palette.sidebar?.hover },
  borderRadius: "8px",
  gap: "8px"
}))
export default SidebarSubMenu
